'use client';
import { OAuthLink } from '@/contexts/OAuthFlowContext';

interface CommentContentProps {
  content: string;
  isApiSelect?: boolean;
}

export function CommentContent({ content, isApiSelect = false }: CommentContentProps) {
  // Parse @mentions in the content
  const parseContent = (text: string) => {
    const mentionRegex = /@(\w+)/g;
    const parts = text.split(mentionRegex);

    return parts.map((part, index) => {
      // Every odd index is a username (captured group from regex)
      if (index % 2 === 1) {
        return (
          <OAuthLink
            key={index}
            href={isApiSelect ? `/api/v1/select/${part}` : `/${part}`}
            className="font-medium"
            style={{ color: '#40A6FF' }}
          >
            @{part}
          </OAuthLink>
        );
      }
      return part;
    });
  };

  return (
    <div className="text-zinc-100 whitespace-pre-wrap break-words">{parseContent(content)}</div>
  );
}
